import React from "react";
import {NavLink} from "react-router";
import {ArrowBackIos} from "@mui/icons-material";
import {Button, Paper, Stack, Box, Typography} from "@mui/material";
import {useLocationFormState} from "../../components/providerUser/ProviderUserForm/ProviderUserAddForm";
import ProviderUserAddFormProvider from "../../components/providerUser/ProviderUserForm/ProviderUserAddFormProvider";
import {useTitle} from 'react-use';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const ProviderUserAddEditPage = () => {

    useTitle(t`Add Provider User`);

    return (
        <Box data-testid="ProviderUser-add-form">
            <Paper sx={ { padding: "2em" } }>
                <Stack direction="column" spacing={1}>
                    <Typography
                        sx={ { flex: '1 1 100%' } }
                        variant="h6"
                        component="div"
                        data-testid="ProviderUser-add-title"
                    >
                        <Trans>Add Provider User</Trans>
                    </Typography>
                    <ProviderUserAddFormProvider
                        cancelButton={
                            <Button size="medium" variant="contained" color="inherit" startIcon={<ArrowBackIos />}
                                    component={NavLink}
                                    to=".."
                                    relative="path"
                                    viewTransition={true}
                            >
                                <Trans>Cancel</Trans>
                            </Button>
                        }
                        initialFormState={useLocationFormState}
                    />
                </Stack>
            </Paper>
        </Box>
    )
}

export default ProviderUserAddEditPage;
